export default __webpack_public_path__ + "static/media/ye.4b3ca24e.svg";